<template>
  <div class="my-login">
    <div class="center-login">
      <img
        @click="handleCloseLogin"
        class="close"
        src="../../../assets/close2.png"
      />
      <img
        class="bg1"
        :src="
          !isRegister
            ? require('../../../assets/login/bg.png')
            : require('../../../assets/login/register-bg.png')
        "
      />
      <img class="user" src="../../../assets/login/user.png" />
      <img class="psw" src="../../../assets/login/psw.png" />
      <img
        @click="handleLoginOrRegister"
        class="login-img"
        :src="
          !isRegister
            ? require('../../../assets/login/login.png')
            : require('../../../assets/login/register-btn.png')
        "
      />
      <img
        @click="handleShowRegister"
        class="register-img"
        :src="
          !isRegister
            ? require('../../../assets/login/register.png')
            : require('../../../assets/login/user-login.png')
        "
      />
      <input v-model="user" class="user-input input" placeholder="请输入账号" />
      <input v-model="pwd" class="psw-input input" placeholder="请输入密码" />
      <!-- <img class="ice-open" src="../../../assets/login/ice-open.png" /> -->
      <!-- <img class="ice-open" src="../../../assets/login/ice-close.png" /> -->
      <img
        class="read"
        src="../../../assets/login/read.png"
      />
      <div @click="handleXieYi" class="open-xieyi" />
      <div v-if="!ok" @click="ok = true" class="no-ok" />
      <img
        v-if="ok"
        @click="ok = false"
        class="ok"
        src="../../../assets/login/ok.png"
      />
    </div>
  </div>
</template>
   
  <script>
export default {
  data() {
    return {
      user: "",
      pwd: "",
      ok: false,
    };
  },
  props: {
    activeIndex: {
      type: [String, Number],
      default() {
        return 0;
      },
    },
    isRegister: {
      type: [String, Number, Boolean],
      default() {
        return false;
      },
    },
  },
  methods: {
    handleLoginOrRegister() {
      const user = localStorage.getItem("user");
      const pwd = localStorage.getItem("pwd");
      if (!this.user) {
        this.$message.error("请输入账号！");
        return false;
      }
      if (!this.pwd) {
        this.$message.error("请输入密码！");
        return false;
      }
      if (!this.ok) {
        this.$message.error("请先阅读并同意协议");
        return false;
      }
      if (!this.isRegister) {
        if (user && pwd) {
          if (user == this.user && pwd == this.pwd) {
            this.$message.success("登录成功！");
            this.$emit("handleLogin", this.user);
          } else {
            this.$message.error("请先进行账号注册！");
            return false;
          }
        } else {
          this.$message.error("请先进行账号注册！");
          return false;
        }
      } else {
        this.$message.success("注册成功！");
        localStorage.setItem("user", this.user);
        localStorage.setItem("pwd", this.pwd);
        this.$emit("handleLogin", this.user);
      }
    },
    handleCloseLogin() {
      this.$emit("handleCloseLogin", false);
    },
    handleXieYi() {
      window.open("https://doc.longmaotech.com/gzlm_xieyi.html");
    },
    handleShowRegister() {
      this.isRegister = !this.isRegister;
      this.user = "";
      this.pwd = "";
      this.ok = false;
    },
    handleOk() {
      this.ok = !this.ok;
    },
  },
  // 组件逻辑
};
</script>
   
<style scoped>
@import url(../../../../css/login-phone.min.css);
</style>


// WEBPACK FOOTER //
// src/components/mobile/login/Login.vue